import { Component, OnDestroy } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { CookieConsentBannerComponent } from '@features/legal/components/cookie-consent-banner.component';
import { LayoutComponent } from '@shared/components/layout/layout.component';
import { RibbonComponent } from '@shared/components/ribbon/ribbon.component';
import { LToastComponent } from '@shared/components/toast';
import { GlobalSpinnerService } from '@shared/services/global-spinner/global-spinner.service';
import { ParamsService } from '@shared/services/params/params.service';
import { ThemeService } from '@shared/services/theme/theme.service';
import { Subscription, filter } from 'rxjs';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, LayoutComponent, RibbonComponent, LToastComponent, CookieConsentBannerComponent],
  template: `
      <l-layout [fullscreen]="fullscreen">
        <router-outlet />
      </l-layout>

      <l-toast />

      <l-ribbon />
      <l-cookie-consent-banner />
   `
})
export class AppComponent implements OnDestroy {
  constructor(router: Router, params: ParamsService, route: ActivatedRoute, themeService: ThemeService, globalSpinnerService: GlobalSpinnerService) {
    params.initialize();
    themeService.initialize();
    globalSpinnerService.initialize();

    const syncFullscreen = () => {
      this.fullscreen = this.resolveRouteData(route)['fullscreen'] === true;
    };

    syncFullscreen();
    this.routerSubscription = router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe(() => syncFullscreen());
  }

  private resolveRouteData(route: ActivatedRoute): Record<string, unknown> {
    let current: ActivatedRoute = route;

    while (current.firstChild) {
      current = current.firstChild;
    }

    return current.snapshot.data;
  }

  private readonly routerSubscription?: Subscription;

  public fullscreen = false;

  public ngOnDestroy(): void {
    this.routerSubscription?.unsubscribe();
  }
}
